import { Alert } from '@lokalise/louis';

import useSelector from '@app/hooks/useSelector';

import { getProjectId, getQaIssues, getQaTotalCount } from '../../reducers/downloadData/selectors';
import QaPopover from './components/QaPopover';

const QaAlertContainer = () => {
    const issues = useSelector(getQaIssues);
    const total = useSelector(getQaTotalCount);
    const projectId = useSelector(getProjectId);

    if (!issues || !total || !projectId) {
        return null;
    }

    return (
        <Alert status="warning">
            Your project contains{' '}
            <div>
                <QaPopover issues={issues} projectId={projectId}>
                    {total} QA issues
                </QaPopover>
                .
            </div>
        </Alert>
    );
};

export default QaAlertContainer;
